export default "__VITE_ASSET__DbUE_wki__"